export const FETCH_PERMISSION_POLICY_REQUEST = 'FETCH_PERMISSION_POLICY_REQUEST';
export const FETCH_PERMISSION_POLICY_SUCCESS = 'FETCH_PERMISSION_POLICY_SUCCESS';
export const FETCH_PERMISSION_POLICY_FAILURE = 'FETCH_PERMISSION_POLICY_FAILURE';

export const SAVE_PERMISSION_POLICY_REQUEST = 'SAVE_PERMISSION_POLICY_REQUEST';
export const SAVE_PERMISSION_POLICY_SUCCESS = 'SAVE_PERMISSION_POLICY_SUCCESS';
export const SAVE_PERMISSION_POLICY_FAILURE = 'SAVE_PERMISSION_POLICY_FAILURE';
